import React, { useEffect, useState } from 'react'
import { AiOutlineFileGif} from 'react-icons/ai'
import { IoIosSettings } from 'react-icons/io'
import { IoTrashSharp } from 'react-icons/io5'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import NewFormWizardChild from '../../../../components/formWizard/NewFormWziardChild'
import Layout from '../../../../components/layouts/Layout'
import { LoadingSpinner } from '../../../../components/Loader/Loader'
import http, { URL_S3 } from '../../../../config/BaseUrl'
import GifModal from '../../components/Modal/GifModal'
import GifSettingsModal from '../../components/Modal/GifSettingsModal'
import { eventGif } from '../slice/createEventSlice'

const Gif = () => {

    const history = useHistory()
    const dispatch = useDispatch()
    const { event_option, event_gif , eventId} = useSelector(state => state.createEvent)
    const [selectGifItems, setSelectGifItems] = useState([])
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [gifId, setGifId] = useState(null)
    const [gifTemplateErr, setGifTemplateErr] = useState(false)

    const handelSubmitGif = (e) => {
        e.preventDefault();
        if(selectGifItems.length > 0){
            dispatch(eventGif(selectGifItems))
            setLoading(true)
            http.post('gif-setting',{ gif_setting: selectGifItems, eventId })
            .then(res => {
                setLoading(false)
                if (res.data.status === true) {
                    if (event_option) {
                            if  (event_option.brust_gif         === true) { history.push('/event/brust-gif', eventId) }
                        else if (event_option.email             === true) { history.push('/event/email', eventId) }
                        else if (event_option.text_messaging    === true) { history.push('/event/sms', eventId) }
                        else if (event_option.digital_props     === true) { history.push('/event/digital-prop', eventId) }
                        else if (event_option.water_mark        === true) { history.push('/event/custom-branding', eventId) }
                        else if (event_option.microsite         === true) { history.push('/event/microsite', eventId) }
                        else if (event_option.frame_option      === true) { history.push('/event/frame', eventId) }
                        else if (event_option.incentive_offer   === true) { history.push('/event/incentive-offer', eventId) }
                        else if (event_option.filters           === true) { history.push('/event/filter', eventId) }
                        else if (event_option.form_builder === true) { history.push('/event/form-builder', eventId) }
                        else { history.push('/event/summary', eventId) }
                    }
                }
                
            })
            .catch()
        }else{
            setGifTemplateErr(true)
        }
    }

    useEffect(() => {
        if (event_gif) {
            if (event_gif.length > 0) {
                setSelectGifItems(event_gif)
            }
        }
    }, [event_gif])

    
    const setGifByProps = (data) => {
        setSelectGifItems(data)
        setGifTemplateErr(false)
    }

    const removeProps = (id) => {
        let copyProps = [...selectGifItems]
        copyProps.splice(id, 1)
        setSelectGifItems(copyProps)
  
    }
    
    const saveAsDraft = () => {
        if(selectGifItems.length > 0){
            dispatch(eventGif(JSON.stringify(selectGifItems)))
            setDraftLoading(true)
            http.post('gif-setting',{ gif_setting: selectGifItems, eventId }).then(res => {
                if (res.data.gif_setting === 'success') {
                    setDraftLoading(false)
                }
            }).catch(err => setDraftLoading(false))
        }else{
            setGifTemplateErr(true)
        }
        
    }

    const submitTrigger = (data) => {
        let copyData = [...selectGifItems]
    
        let indexItem = copyData.findIndex(item => item.id == data.gifId)
        delete copyData[indexItem].settings
        if (indexItem >= 0) {
            copyData[indexItem]['settings'] = data
        }
    
        setSelectGifItems(copyData)
    
    }

    const settingsOpen = (item) => {
        setGifId(item)
        setOpenModal(true)
    }
    const BackToPreviousPage = (e) => {
        e.preventDefault()
        if (event_option.social_media   === true) { history.push('/event/social') }
        else { history.push('/event/options') }
    }

    return (
        <Layout>
            <NewFormWizard />
            <NewFormWizardChild />
            <form onSubmit={handelSubmitGif}>
            <section className="mt-4"> 
                <div className="row justify-content-center">
                    <div className="col-md-10">
                        <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="text-center col-12 col-md-12">
                                        <div className="">
                                            <p className="mb-0 display-4 text-primary event-form-title">3 in 1 Animation Chooser</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className="mt-2 mb-3 row justify-content-center">
                        <div className="col-md-10">
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex align-items-center">
                                            <AiOutlineFileGif size={30} />
                                            <p className="mb-0 ml-2 font-size-16">Animation Library</p>
                                        </div>
                                      
                                        <div className="float-right">
                                            <button type="button" className="btn btn-outline-primary" data-toggle="modal" data-target="#props-filter-modal">Select 3 in 1 Animation</button>
                                            <GifModal setData={setGifByProps} selectGifItems={selectGifItems} />
                                            </div>
                                        </div>
                                        {gifTemplateErr &&
                                            <p className={`pt-2 mb-0 text-danger font-weight-bold text-right fade ${gifTemplateErr ? 'show' : 'hide'}`}>Choose any animation </p>
                                        }
                                    <div className="prop__area">
                                        <div className="flex-wrap props-list d-flex">
                                        {
                                            selectGifItems.length > 0 ?
                                                selectGifItems.map((propItem, index) => (
                                                    <div className="prop__item" key={`digital-props-index-${index}`}>
                                                        <img src={`${URL_S3}image/gif/preview_image/${propItem.image}`} className="img-fluid" alt="props-data" />
                                                        <div className="remove-props d-flex justify-content-around align-items-center">
                                                            <span className="font-small" onClick={removeProps.bind(this, index)}>
                                                            <IoTrashSharp />
                                                            </span>
                                                            <span className="font-small" onClick={settingsOpen.bind(this, propItem)}>
                                                                <IoIosSettings />
                                                            </span>
                                                        </div>
                                                    </div>
                                                ))

                                                :
                                                <div className="prop__no__item">
                                                    <h4>No 3 in 1 Animation Selected.</h4>
                                                </div>
                                        }

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                    <div className="my-5 row justify-content-center">
                      <div className="col-md-10">
                          <button type="button" onClick={BackToPreviousPage} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>
                          {loading ?
                              (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                  <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                              </button>)
                              : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                          }

                          {
                              loading ?
                                  (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                      <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                  </button>)
                                  :
                                  <button type="button" onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                          }
                      </div>
                  </div>
                    <GifSettingsModal 
                        isOpen={openModal} 
                        gifId={gifId && gifId.id} 
                        closeModal={setOpenModal} 
                        submitTrigger={submitTrigger} 
                        selectedSettings={gifId && gifId.settings}
                        canSetCustomFrame={false}
                    />
            </section>
            </form>
        </Layout>
    )
}

export default Gif
